import React, { Component } from 'react';
import {
  Button,
  Divider,
  Paper,
  TextField,
  Grid,
  Modal
} from '@material-ui/core';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import SimilarNames from '../shared/SimilarNames';
import ConfirmAddSimilarModal from './ConfirmAddSimilarModal';
import { isUniqueString, similarStrings } from '../../helpers/helpers';

import '../../assets/stylesheets/Setting.css';

const initialState = {
  value: '',
  error: false,
  similarNames: [],
  showConfirmModal: false
};

class AddSingleFieldModal extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  closeConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handleAdd = () => {
    this.setState({ showConfirmModal: true });
  };

  handleChange = event => {
    const { value } = event.target;

    const { existingFieldNames } = this.props;

    const error = !isUniqueString(value, existingFieldNames);

    const similarNames = existingFieldNames.length ? similarStrings(value, existingFieldNames) : [];

    this.setState({
      value,
      error,
      similarNames
    });
  };

  handleConfirm = () => {
    const { onAddField } = this.props;
    const { value } = this.state;
    this.setState({ showConfirmModal: false }, () => onAddField(value));
  };

  onClose = () => {
    const { onClose } = this.props;
    this.setState(initialState, () => onClose());
  };

  render() {
    const {
      confirmMessage,
      instruction,
      fieldLabel,
      fieldName,
      showModal,
    } = this.props;
    const { error, similarNames, showConfirmModal, value } = this.state;
    return (
      <>
        <Modal open={showModal} onClose={this.onClose}>
          <Paper className="deleteModal">
            <>
              <Grid container>
                <Grid item xs={12}>
                  {instruction}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    error={error}
                    id={instruction}
                    label={fieldLabel}
                    name={fieldName}
                    autoFocus
                    onChange={this.handleChange}
                  />
                  <Divider />
                  <br />
                </Grid>
                <SimilarNames similarNames={similarNames} divider />
                <Grid item xs={6}>
                  <Button
                    onClick={this.handleAdd}
                    disabled={error || value === ''}
                    className="ssenseButton ssensePrimary"
                  >
                    {i18n.t('add')}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    onClick={this.onClose}
                    className="ssenseButton ssenseDefault"
                  >
                    {i18n.t('cancel')}
                  </Button>
                </Grid>
              </Grid>
            </>
          </Paper>
        </Modal>
        <ConfirmAddSimilarModal
          confirmMessage={confirmMessage}
          showModal={showConfirmModal}
          onClose={this.closeConfirmModal}
          handleConfirm={this.handleConfirm}
          itemName={value}
          similarNames={similarNames}
        />
      </>
    );
  }
}

AddSingleFieldModal.propTypes = {
  confirmMessage: PropTypes.string.isRequired,
  instruction: PropTypes.string.isRequired,
  fieldLabel: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onAddField: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  existingFieldNames: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default AddSingleFieldModal;
